import { RectangleLayerSpecification } from '../chart-props';
import { VectorDrawFunction } from './type';

export const drawRectangleLayer: VectorDrawFunction<RectangleLayerSpecification> = (pass, features, layer, xAxis, yAxis, featureState) => {
    for (let i = 0; i < features.length; i++) {
        const feature = features[i];
        if (layer.filter && !layer.filter(feature, i)) {
            continue;
        }

        if (feature.geometry.type !== 'Polygon') {
            continue;
        }

        pass.drawer.drawPolygon(
            feature.geometry.coordinates.map(([x, y]) => [xAxis.project(x, pass.viewState), yAxis.project(y, pass.viewState)]),
            {
                color: layer.paint.fill
            },
            {
                width:
                    typeof layer.paint.outlieWidth === 'function'
                        ? layer.paint.outlieWidth(feature, feature.id ? featureState?.[feature.id] : undefined)
                        : layer.paint.outlieWidth,
                color: layer.paint.outlineColor ?? layer.paint.fill
            }
        );
    }
};
